import React from 'react'
import {
  Box,
  Image,
} from "@chakra-ui/react";
import { FaEnvelope, FaGithub, FaLinkedin, FaMailBulk } from "react-icons/fa";
function Picture() {
  return (
    <Box padding={'20px'} borderColor={'rgb(26,32,45)'} borderWidth={'2px'} backgroundColor={'white'}>
            <Image width={'400px'}  src={'pic32.JPG'} alt={"GIF"} />
            <Box height={'100px' } display={'flex'} justifyContent={'center'} alignItems={'center'} >
              <Box display={'flex'}  flex={1} flexBasis={0} justifyContent={'center'} alignItems={'center'}> 
                <a href="https://github.com/hamza-al" target="_blank" rel="noopener noreferrer"><FaGithub color={"black"} size={50} /></a>
              </Box>
              <Box flex={1} flexBasis={0}  display={'flex'}  justifyContent={'center'} alignItems={'center'}>
                <a href="https://www.linkedin.com/in/hamza-al-sorkhy-7024021b9/" target="_blank" rel="noopener noreferrer"><FaLinkedin color={"black"} size={50} /> </a>
              </Box>
              <Box flex={1} flexBasis={0}  display={'flex'}  justifyContent={'center'} alignItems={'center'}>
                <a href="mailto:alsorkhyy@gmail.com" target="_blank" rel="noopener noreferrer"><FaEnvelope color={"black"} size={50} /> </a>
              </Box>
            </Box>
          </Box>
  )
}

export default Picture